import type { DocumentContext } from '@/document-render/domain/DocumentContext';
import { normalizeDocumentContext } from '@/document-render/application/normalizeDocumentContext';
import type { PreviewContextSource } from '@/document-render/presentation/PreviewContextProvider';

/**
 * THE ONE "SAMPLE DATA" SWITCH (LLAMS-610 DB-13, KIND-03) shared by the block and the template
 * editor canvases.
 *
 * - `sampleData === true`: the sample context (API / scenario / mock fallback) is rendered with its
 *   values bound — every kind shows sample values.
 * - `sampleData === false`: the sample context is dropped and the preview context is the
 *   structure-safe EMPTY one (`defaults: 'empty'`: no sample customer, quote, line items, totals or
 *   price book) with unbound variable bindings, so every kind falls to its token placeholder /
 *   empty state. No renderer carries a sample fallback of its own.
 * - A real host context (`source === 'host'`) is never replaced: it carries the embedding
 *   product's own record, not sample data.
 */
export function applySampleDataSwitch(context: DocumentContext, source: PreviewContextSource, sampleData: boolean): DocumentContext {
  if (source === 'host') return context;

  if (sampleData) return { ...context, previewValueBinding: 'bound' };

  return { ...normalizeDocumentContext({}, { defaults: 'empty' }), previewValueBinding: 'unbound' };
}
